import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { FormMode } from '@/types/form';

// Create a context to provide formMode to the cell renderer
const FormModeContext = React.createContext<FormMode>('view');

// Provider component
export const FormModeProvider: React.FC<{
  formMode: FormMode;
  children: React.ReactNode;
}> = ({ formMode, children }) => {
  return <FormModeContext.Provider value={formMode}>{children}</FormModeContext.Provider>;
};

// Hook to use the form mode
export const useFormMode = () => React.useContext(FormModeContext);

// The actual cell renderer component
const AritoCheckboxCellRenderer = (params: any) => {
  const formMode = useFormMode();

  return (
    <div className='flex h-full items-center justify-center'>
      <Checkbox
        checked={!!params.value}
        disabled={formMode === 'view'}
        className='size-3.5'
        onCheckedChange={checked => {
          if (formMode === 'view') return;
          params.api.setEditCellValue?.(
            {
              id: params.id,
              field: params.field,
              value: checked
            },
            undefined
          );
        }}
      />
    </div>
  );
};

export default AritoCheckboxCellRenderer;
